/**
 * Идентификатор серверной записи пресета по его ключу с заданным началом либо `null`, если ключ
 * не такой. Начало ключа у пресетов таблицы и у дашбордов своё, а запись сервера стоит после него.
 */
export const parseServerPresetId = (presetId: string, prefix: string): number | null => {
  if (!presetId.startsWith(prefix)) return null;
  const serverId = Number(presetId.slice(prefix.length));
  return Number.isInteger(serverId) ? serverId : null;
};

/**
 * Разбор ключей серверных пресетов списка: идентификатор записи на сервере либо `null`, если ключ
 * принадлежит пресету другого вида. Формат ключа у пресетов таблицы и у дашбордов свой.
 */
export type ServerPresetKeyParsers = {
  /** Ключ системного пресета */
  parseSystemId: (presetId: string) => number | null;
  /** Ключ совместного пресета */
  parseSharedId: (presetId: string) => number | null;
};

/** Серверный пресет, названный ключом: его вид и запись на сервере. */
export type ServerPresetKey = {
  kind: 'system' | 'shared';
  id: number;
};

/** Серверный пресет по ключу либо `null`, если ключ принадлежит личному пресету. */
export const resolveServerPresetKey = (
  presetId: string,
  { parseSystemId, parseSharedId }: ServerPresetKeyParsers,
): ServerPresetKey | null => {
  const systemId = parseSystemId(presetId);
  if (systemId !== null) return { kind: 'system', id: systemId };
  const sharedId = parseSharedId(presetId);
  if (sharedId !== null) return { kind: 'shared', id: sharedId };
  return null;
};
